function selectedPurchaseQuantity() {
  const input = document.getElementById('purchase-quantity');
  const value = Number(input?.value);
  return Math.min(10, Math.max(1, Number.isFinite(value) ? Math.trunc(value) : 1));
}

function nextBusinessShipDate(now = new Date(), timeZone = 'visitor') {
  if (timeZone === 'visitor') timeZone = undefined;
  const parts = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(now);
  const part = type => Number(parts.find(item => item.type === type).value);
  const date = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
  let daysAhead = 0;
  do {
    date.setUTCDate(date.getUTCDate() + 1);
    daysAhead += 1;
  } while (date.getUTCDay() === 0 || date.getUTCDay() === 6);
  const day = date.getUTCDate();
  const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
  const month = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short' }).format(date);
  const weekday = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'long' }).format(date);
  return {
    iso: date.toISOString().slice(0, 10),
    label: daysAhead === 1 ? 'Ships tomorrow:' : `Ships ${weekday}:`,
    display: `${month} ${day}${suffix}`
  };
}

function initShippingEstimate(root) {
  const estimate = root.querySelector('[data-shipping-estimate]');
  if (!estimate || estimate.dataset.initialized) return;
  estimate.dataset.initialized = 'true';
  const update = () => {
    if (!estimate.isConnected) {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', update);
      document.removeEventListener('period:offer-change', update);
      return;
    }
    const shipping = nextBusinessShipDate(new Date(), estimate.dataset.timeZone);
    estimate.querySelector('[data-ship-label]').textContent = shipping.label;
    const date = estimate.querySelector('[data-ship-date]');
    date.textContent = shipping.display;
    date.dateTime = shipping.iso;
    estimate.hidden = selectedPurchaseQuantity() > Number(estimate.dataset.stock);
  };
  const timer = setInterval(update, 60000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('period:offer-change', update);
  update();
}

function initPeriod(root = document) {
  const subscription = root.querySelector('#subscription');
  const oneTime = root.querySelector('#one-time');
  if (subscription && oneTime && !subscription.dataset.initialized) {
    subscription.dataset.initialized = 'true';
    const quantityInput = root.querySelector('#purchase-quantity');
    const quantityMinus = root.querySelector('[data-quantity-minus]');
    const quantityPlus = root.querySelector('[data-quantity-plus]');
    const updateSelection = () => {
      const subscribed = subscription.checked;
      const quantity = selectedPurchaseQuantity();
      const total = `$${quantity * (subscribed ? 44 : 55)}`;
      if (quantityMinus) quantityMinus.disabled = quantity <= 1;
      if (quantityPlus) quantityPlus.disabled = quantity >= 10;
      document.getElementById('subscription-card').classList.toggle('selected', subscribed);
      document.getElementById('one-time-card').classList.toggle('selected', !subscribed);
      document.getElementById('gift-heading').textContent = subscribed
        ? 'Your free gifts!' : 'Free with subscription';
      const label = document.getElementById('button-label');
      if (label) {
        label.textContent = 'add to cart';
        document.getElementById('button-price').textContent = `${total} →`;
        document.getElementById('charge-copy').textContent = subscribed
          ? `${total} today, then ${total} every 30 days until canceled. Free shipping. Taxes calculated at checkout.`
          : `${total} once. Taxes and shipping calculated at checkout.`;
      }
      const previewPrice = document.getElementById('preview-button-price');
      if (previewPrice) previewPrice.textContent = `${total} →`;
      document.dispatchEvent(new CustomEvent('period:offer-change', { detail: { subscribed } }));
    };
    if (quantityInput) {
      quantityInput.addEventListener('input', updateSelection);
      const normalizeQuantity = () => {
        quantityInput.value = selectedPurchaseQuantity();
        updateSelection();
      };
      quantityInput.addEventListener('change', normalizeQuantity);
      quantityInput.addEventListener('blur', normalizeQuantity);
      [[quantityMinus, -1], [quantityPlus, 1]].forEach(([button, step]) => {
        button.addEventListener('click', () => {
          quantityInput.value = Math.min(10, Math.max(1, selectedPurchaseQuantity() + step));
          updateSelection();
        });
      });
    }
    [subscription, oneTime].forEach(input => {
      input.addEventListener('change', updateSelection);
      input.closest('.plan').addEventListener('click', event => {
        if (event.target.closest('label, input, a, button, summary')) return;
        if (!input.checked) input.click();
      });
    });
    updateSelection();
  }
  const galleryImage = document.getElementById('product-image');
  const thumbnails = [...root.querySelectorAll('.thumbnails button')];
  thumbnails.forEach((button, index) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      galleryImage.src = button.dataset.image;
      galleryImage.alt = button.dataset.alt;
      galleryImage.classList.toggle('gift-view', index !== 0);
      thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    });
  });
  initCartPreview(root);
  initShippingEstimate(root);
}

function initCartPreview(root) {
  const trigger = root.querySelector('#cart-preview-button');
  const drawer = root.querySelector('#PeriodCartDrawer');
  if (!trigger || !drawer || trigger.dataset.initialized) return;
  trigger.dataset.initialized = 'true';
  let quantity = 0;
  let closeTimer;
  let returnFocus;
  let keyboardInteraction = false;
  const currency = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
  const subscribed = () => document.getElementById('subscription').checked;
  const welcomeGiftValue = Number(drawer.dataset.welcomeGiftValue);
  const render = () => {
    if (!drawer.isConnected) return;
    const isSubscription = subscribed();
    const total = quantity * (isSubscription ? 44 : 55);
    drawer.querySelectorAll('[data-cart-content]').forEach(element => { element.hidden = quantity === 0; });
    drawer.querySelector('[data-cart-empty]').hidden = quantity !== 0;
    drawer.querySelectorAll('[data-cart-subscriber]').forEach(element => { element.hidden = !isSubscription; });
    drawer.querySelector('[data-cart-count]').textContent = quantity;
    drawer.querySelector('[data-cart-quantity]').textContent = quantity;
    drawer.querySelector('[data-cart-minus]').disabled = quantity <= 1;
    drawer.querySelector('[data-cart-line-price]').textContent = currency(total);
    drawer.querySelectorAll('[data-cart-original], [data-cart-total-original]').forEach(original => {
      original.hidden = !isSubscription;
      original.textContent = currency(quantity * 55);
    });
    drawer.querySelector('[data-cart-subtotal]').textContent = currency(total);
    drawer.querySelector('[data-cart-savings]').textContent = `−${currency(quantity * 11)}`;
    // A first-delivery gift set is awarded once per customer, not once per bottle.
    const bundleValue = quantity * 55 + (quantity > 0 ? welcomeGiftValue : 0);
    const bundlePercent = bundleValue > 0 ? Math.round((bundleValue - total) / bundleValue * 100) : 0;
    drawer.querySelector('[data-cart-bundle-value]').textContent = currency(bundleValue);
    drawer.querySelector('[data-cart-bundle-price]').textContent = currency(total);
    drawer.querySelector('[data-cart-bundle-percent]').textContent = `Save ${bundlePercent}%`;
    drawer.querySelector('[data-cart-plan]').textContent = isSubscription ? 'Delivered every 30 days' : 'One-time purchase';
    drawer.querySelector('[data-cart-renewal]').textContent = isSubscription
      ? `${currency(total)} every 30 days. Skip, pause or cancel.` : 'One-time purchase. No recurring charges.';
    drawer.querySelector('[data-cart-shipping]').textContent = isSubscription
      ? 'Free shipping. Taxes calculated at checkout.' : 'Taxes & shipping calculated at checkout.';
    drawer.querySelector('[data-cart-switch]').hidden = isSubscription;
  };
  const finishClose = () => {
    drawer.classList.remove('is-closing');
    drawer.close();
  };
  const close = () => {
    if (!drawer.open || drawer.classList.contains('is-closing')) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { finishClose(); return; }
    drawer.classList.add('is-closing');
    closeTimer = setTimeout(finishClose, 220);
  };
  trigger.addEventListener('click', event => {
    keyboardInteraction = event.detail === 0;
    clearTimeout(closeTimer);
    returnFocus = document.activeElement;
    quantity += selectedPurchaseQuantity();
    render();
    trigger.classList.remove('is-popping');
    void trigger.offsetWidth;
    trigger.classList.add('is-popping');
    setTimeout(() => trigger.classList.remove('is-popping'), 550);
    drawer.classList.remove('is-closing');
    document.body.classList.add('cart-is-open');
    if (!drawer.open) drawer.showModal();
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', close));
  drawer.addEventListener('pointerdown', () => { keyboardInteraction = false; });
  drawer.addEventListener('keydown', () => { keyboardInteraction = true; });
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  drawer.addEventListener('click', event => { if (event.target === drawer) close(); });
  drawer.addEventListener('close', () => {
    clearTimeout(closeTimer);
    document.body.classList.remove('cart-is-open');
    if (returnFocus?.isConnected) {
      returnFocus.classList.toggle('pointer-focus-return', !keyboardInteraction);
      returnFocus.focus({ preventScroll: true });
    }
  });
  trigger.addEventListener('blur', () => trigger.classList.remove('pointer-focus-return'));
  drawer.querySelector('[data-cart-minus]').addEventListener('click', () => { quantity = Math.max(1, quantity - 1); render(); });
  drawer.querySelector('[data-cart-plus]').addEventListener('click', () => { quantity += 1; render(); });
  drawer.querySelector('[data-cart-remove]').addEventListener('click', () => {
    quantity = 0;
    render();
    drawer.querySelector('[data-cart-empty] button').focus();
  });
  drawer.querySelector('[data-cart-switch]').addEventListener('click', () => {
    const input = document.getElementById('subscription');
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    drawer.querySelector('.cart-close').focus({ preventScroll: true });
  });
  document.addEventListener('period:offer-change', render);
  render();
}
initPeriod();
document.addEventListener('keydown', () => {
  document.querySelectorAll('.pointer-focus-return').forEach(element => element.classList.remove('pointer-focus-return'));
});
document.addEventListener('shopify:section:load', event => initPeriod(event.target));
document.addEventListener('click', event => {
  const link = event.target.closest('a');
  if (!link) return;
  if (link.hash === '#gifts') {
    const subscription = document.getElementById('subscription');
    if (subscription) { subscription.checked = true; subscription.dispatchEvent(new Event('change')); }
  }
  if (link.hasAttribute('data-open-ingredients')) {
    const ingredients = document.getElementById('ingredients');
    if (ingredients) ingredients.open = true;
  }
});
if (location.hash === '#ingredients') {
  const ingredients = document.getElementById('ingredients');
  if (ingredients) ingredients.open = true;
}
